import vAbi from "./ABIS/veriface_abi.json";

export const VERIFACE_ADDRESS = "0xb3C64A8D69E5C9A2A610329A5a4A7faA82c64BFD";
export const VERIFACE_ABI = vAbi["abi"];
